module.exports = __webpack_public_path__ + "img/CY.d2e18ce7.svg";